import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Theme } from '../theme/theme';

const theme = createTheme({
  palette: {
    primary: { main: Theme.PRIMARY_COLOR },
    secondary: { main: Theme.SECONDARY_COLOR },
    text: { primary: Theme.SECONDARY_TEXT_COLOR },
    background: { default: Theme.BG_COLOR },
  },
});

export function MuiThemeProvider({ children, muiTheme }: { children: React.ReactNode; muiTheme?: ReturnType<typeof createTheme> }) {
  return <ThemeProvider theme={muiTheme ?? theme}>{children}</ThemeProvider>;
}

export default MuiThemeProvider;
